import { IWebGLLockEntry, LockInstanceController } from "./webgl_ui/webgl_ui_lock.js";
import { IWebGLGlintEntry, GlintInstanceController } from "./webgl_ui/webgl_ui_glint.js";
import { WebGLUIRuntime } from "./webgl_ui_runtime.js";

export class WebGLUIManager
{
  public static addLock( entry: IWebGLLockEntry, start_time: number ): LockInstanceController
  {
    return WebGLUIRuntime.getUILock().spawn( entry, start_time );
  }

  public static addGlint( entry: IWebGLGlintEntry, start_time: number ): GlintInstanceController
  {
    return WebGLUIRuntime.getUIGlint().spawn( entry, start_time );
  }
}
